const quoteArray2 = [
  `"Pharmaceutical experience drives my Good Documentation Practices (GDPs)."`,
  `"Front-load effort, spend time to understand the problem before proposing a solution."`,
  `"Successful projects are planned before implementation, and tested before release."`,
]

export default quoteArray2;
